import React from "react";
import PageMeta from "../site/PageMeta";
import Marquee from "../site/Marquee";
import HomeHero from "../home/HomeHero";
import HomeProblem from "../home/HomeProblem";
import HomeApproach from "../home/HomeApproach";
import HomePillars from "../home/HomePillars";
import HomeComparison from "../home/HomeComparison";
import HomeProcess from "../home/HomeProcess";
import HomeEngagement from "../home/HomeEngagement";
import HomeTestimonials from "../home/HomeTestimonials";
import HomeFounder from "../home/HomeFounder";
import HomeFinalCTA from "../home/HomeFinalCTA";

const marqueeItems = [
  "AI-Assisted *Workflows*",
  "Human-Led *Delivery*",
  "Recruiting · Operations · *Knowledge*",
  "Accountable *End-to-End*",
  "One *Operating* Layer",
  "US · UK · *EU*",
];

export default function Home() {
  return (
    <>
      <PageMeta
        title="A4 Assist — AI-Powered Operations. Human-Led Delivery."
        description="A4 Assist combines AI-enabled workflows with trained specialists to run your recruiting (RPO), operations (BPO), and data & research work (KPO) — accountable, end-to-end."
      />
      <HomeHero />
      <Marquee items={marqueeItems} />
      <HomeProblem />
      <HomeApproach />
      <HomePillars />
      <HomeComparison />
      <HomeProcess />
      <HomeEngagement />
      <HomeTestimonials />
      <HomeFounder />
      <HomeFinalCTA />
    </>
  );
}
